import React from 'react'
import {Obra} from "../../types/Obra";
import './RelacionaObraEndereco.scss'
import {IOrcamento} from "../../types/IOrcamento";
import {useAppSelector} from "../../redux/hooks";

export type RelacionaObraEnderecoProps = {
    obras: Obra[]
    obraSelecionada?: number
    handleChange: (obraId: Obra) => void
}

export const RelacionaObraEndereco = (props: RelacionaObraEnderecoProps) => {
    return <>
        <div>
        <span style={{ marginRight: "4px", marginTop: "4px" }}>Obra</span>
        <select value={(props.obraSelecionada) ?? ""} onChange={(e) => props.handleChange(props.obras.find(o => o?.IdObra === Number(e.target.value)))}>
            <option value={0}>Nenhuma</option>
            {
                props?.obras?.map((item) => (
                    <option key={item?.IdObra} value={item?.IdObra}>{item.Apelido}</option>
                ))
            }
        </select>
        </div>
    </>
}
